var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ invalid, handleSubmit, pristine }) {
          return [
            _c(
              "form",
              {
                staticClass: "user form-horizontal",
                attrs: { role: "form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.onSubmit.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "fieldset",
                  [
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_FIRST_NAME"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TT_FIRST_NAME")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "firstName",
                                  attrs: {
                                    rules: "required",
                                    name: "firstName",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-2"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.firstName,
                                                        expression: "firstName"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      name: "firstName",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value: _vm.firstName
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.firstName =
                                                          $event.target.value
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_LAST_NAME"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TT_LAST_NAME")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "lastName",
                                  attrs: {
                                    rules: "required",
                                    name: "lastName",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-5 col-md-2"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.lastName,
                                                        expression: "lastName"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      name: "lastName",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value: _vm.lastName
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.lastName =
                                                          $event.target.value
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_EMAIL"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TT_EMAIL")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "email",
                                  attrs: {
                                    rules: "required|email",
                                    name: "email",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({
                                          classes,
                                          dirty,
                                          valid
                                        }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-6 col-md-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.email,
                                                        expression: "email"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "email",
                                                      name: "email",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value: _vm.email
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.email =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  dirty && !valid
                                                    ? _c("span", {
                                                        directives: [
                                                          {
                                                            name: "t",
                                                            rawName: "v-t",
                                                            value:
                                                              "INVALID_EMAIL_LABEL",
                                                            expression:
                                                              "'INVALID_EMAIL_LABEL'"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "error-details"
                                                      })
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_CONFIRM_EMAIL"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TT_CONFIRM_EMAIL")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "confirmEmail",
                                  attrs: {
                                    name: "confirmEmail",
                                    rules: "required|email|confirmed:email",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({
                                          classes,
                                          dirty,
                                          valid
                                        }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-6 col-md-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.confirmEmail,
                                                        expression:
                                                          "confirmEmail"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "email",
                                                      name: "confirmEmail",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value: _vm.confirmEmail
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.confirmEmail =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  dirty && !valid
                                                    ? _c("span", {
                                                        directives: [
                                                          {
                                                            name: "t",
                                                            rawName: "v-t",
                                                            value:
                                                              "INVALID_CONFIRM_EMAIL_LABEL",
                                                            expression:
                                                              "'INVALID_CONFIRM_EMAIL_LABEL'"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "error-details"
                                                      })
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_ROLE"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TT_ROLE")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { slim: "" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-3 col-md-3" },
                                      [
                                        _c("MultipleToggle", {
                                          ref: "role",
                                          attrs: {
                                            name: "role",
                                            value: _vm.role,
                                            options: _vm.rolesOptions
                                          },
                                          on: { onToggle: _vm.onRoleChange }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _vm.role == "user"
                      ? _c("Field", {
                          attrs: {
                            label: _vm.$t("INPUT_LABEL_CAN_EXPORT"),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TT_CAN_EXPORT")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "ValidationProvider",
                                      { attrs: { slim: "" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-3 col-md-3" },
                                          [
                                            _c("nzToggle", {
                                              on: {
                                                onToggle: _vm.onCanExportChange
                                              },
                                              model: {
                                                value: _vm.canExport,
                                                callback: function($$v) {
                                                  _vm.canExport = $$v
                                                },
                                                expression: "canExport"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                        },
                        [
                          _vm.triedToSend && invalid
                            ? _c(
                                "p",
                                { staticClass: "m-t-8 m-b-8 bright-red" },
                                [
                                  _c("i", {
                                    staticClass:
                                      "f-s-20 p-r-0 typcn typcn-warning"
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$t("INVALID_FORM")) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "PrimaryButton",
                            {
                              attrs: {
                                size: "sm",
                                disabled: pristine,
                                "show-loader-on-form": _vm.showLoader
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("ACTION_CREATE_INVITE")) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "CANCEL",
                                expression: "'CANCEL'"
                              }
                            ],
                            staticClass: "btn btn-sm btn-danger m-l-15",
                            on: { click: _vm.cancel }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }